
import respUtility from '@/mixins/respUtility';

export default {
  name: 'ProductInfoReviewsItem',
  mixins: [respUtility],
  props: {
    review: {
      type: Object,
    },
    isProductPage: {
      type: Boolean,
      default: false,
    },
    view3D: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
